export default "__VITE_ASSET__CPrhHbBT__"